import MonitoringWidgetProvider from './MonitoringWidgetProvider'
import MonitoringWidget from './MonitoringWidget'

export { MonitoringWidget }
export default MonitoringWidgetProvider
